var TabGeneralModule = /** @class */ (function () {
    function TabGeneralModule() {
    }
    return TabGeneralModule;
}());
export { TabGeneralModule };
